import controller from './graphs.controller';

const template = require('./graphs.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/graphs/graphs.component.js